// extracted by mini-css-extract-plugin
export default {"inputField":"AddBankDetailsField__inputField-lAAF","inputLabelContainer":"AddBankDetailsField__inputLabelContainer-QH3L"};